import React from 'react';
import { motion } from 'framer-motion';
import { Check, Shield } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-24 relative overflow-hidden" data-id="element-134">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-brand-accent/5 blur-[150px] rounded-full pointer-events-none" data-id="element-135" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-136">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-137">
          <h2 className="text-brand-accent font-bold tracking-widest uppercase text-sm mb-4" data-id="element-138">
            Pricing Models
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif font-bold text-white mb-6" data-id="element-139">
            Revenue-Positive Scaling
          </h3>
          <p className="text-lg text-slate-400" data-id="element-140">
            We align our incentives with your growth. Choose the model that fits
            your current operational needs.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 items-center" data-id="element-141">
          {/* Side Card 1 */}
          <div className="p-8 rounded-3xl bg-white/5 border border-white/10" data-id="element-142">
            <h4 className="text-xl font-bold text-white mb-4" data-id="element-143">
              Retainer Services
            </h4>
            <p className="text-slate-400 text-sm mb-8" data-id="element-144">
              Best for ongoing operational support and dedicated staffing.
            </p>
            <ul className="space-y-4 mb-8" data-id="element-145">
              {['Dedicated Staff', '24/7 Support', 'Admin Management', 'Full Integration'].map((item, i) => <li key={i} className="flex items-center gap-3 text-sm text-slate-300" data-id="element-146">
                  <Check className="w-4 h-4 text-brand-accent" data-id="element-147" /> {item}
                </li>)}
            </ul>
            <button className="w-full py-3 rounded-xl border border-white/20 font-bold hover:bg-white/5 transition-all" data-id="element-148">
              Contact for Quote
            </button>
          </div>

          {/* Main Featured Card */}
          <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} className="p-10 rounded-[2.5rem] bg-brand-accent text-brand-dark relative shadow-2xl shadow-brand-accent/20" data-id="element-149">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-white text-brand-dark px-6 py-1.5 rounded-full text-xs font-black uppercase tracking-widest shadow-xl" data-id="element-150">
              Most Popular
            </div>
            <h4 className="text-2xl font-black mb-2 uppercase tracking-tight" data-id="element-151">
              Pay As We Book
            </h4>
            <p className="text-brand-dark/70 font-medium mb-8" data-id="element-152">
              Performance-based lead generation.
            </p>

            <div className="mb-8" data-id="element-153">
              <span className="text-5xl font-black" data-id="element-154">$0</span>
              <span className="text-lg font-bold ml-2" data-id="element-155">Per Call / Setup</span>
            </div>

            <ul className="space-y-4 mb-10" data-id="element-156">
              {['Pay only per confirmed appointment', 'No cost per call or outreach', 'Revenue-positive model', 'HIPAA compliant handling', 'Performance guaranteed'].map((item, i) => <li key={i} className="flex items-center gap-3 text-sm font-bold" data-id="element-157">
                  <Check className="w-5 h-5 text-brand-dark" data-id="element-158" /> {item}
                </li>)}
            </ul>

            <button className="w-full py-5 rounded-2xl bg-brand-dark text-white font-black text-lg hover:bg-slate-800 transition-all shadow-xl" data-id="element-159">
              Get Started Now
            </button>
            <div className="mt-6 flex items-center justify-center gap-2 text-xs font-bold opacity-60" data-id="element-160">
              <Shield className="w-4 h-4" data-id="element-161" /> SECURE & COMPLIANT
            </div>
          </motion.div>

          {/* Side Card 2 */}
          <div className="p-8 rounded-3xl bg-white/5 border border-white/10" data-id="element-162">
            <h4 className="text-xl font-bold text-white mb-4" data-id="element-163">
              Performance Lead Gen
            </h4>
            <p className="text-slate-400 text-sm mb-8" data-id="element-164">
              Aggressive outreach for high-volume growth targets.
            </p>
            <ul className="space-y-4 mb-8" data-id="element-165">
              {['Custom Funnels', 'Lead Qualification', 'Email Prospecting', 'CRM Integration'].map((item, i) => <li key={i} className="flex items-center gap-3 text-sm text-slate-300" data-id="element-166">
                  <Check className="w-4 h-4 text-brand-accent" data-id="element-167" /> {item}
                </li>)}
            </ul>
            <button className="w-full py-3 rounded-xl border border-white/20 font-bold hover:bg-white/5 transition-all" data-id="element-168">
              View Packages
            </button>
          </div>
        </div>
      </div>
    </section>;
}